module.exports = __webpack_public_path__ + "img/empty-search-dark.ac0c33e1.svg";